import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-screen w-full flex" }

import siderComponent from "@/components/account/siderComponent.vue";

const __default__ = {
  name: "AccountPage",
};

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { class: "h-full flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_sider, { class: "hidden md:block bg-white w-64 shadow-md" }, {
          default: _withCtx(() => [
            _createVNode(siderComponent)
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout, { class: "flex-1 p-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_header, { class: "bg-white" }),
            _createVNode(_component_a_layout_content, { class: "my-2 bg-white" }),
            _createVNode(_component_a_layout_footer, { class: "bg-white" })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})